import {createLoaderWorker} from '@loaders.gl/loader-utils';
import {BasisLoader} from '../basis-loader';

createLoaderWorker(BasisLoader);
